import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import PrivacyPolicyContent from '../Components/Policy/PrivacyPolicyContent'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'

function PrivacyPolicy() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb title="Privacy Policy" />
            <PrivacyPolicyContent />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default PrivacyPolicy